import React, { useState, useEffect } from 'react';
import Footer from '../../layout/Footer';
import ViewWeightUnit from './ViewWeightUnit';
import { Container, Row, Col, Card, Form, Nav } from 'react-bootstrap';
import SimpleBarReact from "simplebar-react";

// Icons
import Icon from '@mdi/react';
import { mdiFormatListBulletedSquare, mdiPlus, mdiMagnify } from '@mdi/js';

import WeightUnitData from "./weight-unit-data.json";
import FormInputs from '../../../Utils/FormInputs';

export default function WeightUnit() {
    // left navlink active
    useEffect(() => {
        var a = document.getElementsByClassName("left-link-item");
        for (var i = 0; i < a.length; i++) {
            a[i].onclick = function () {
                var b = document.querySelector(".left-link-item a.active");
                if (b) b.classList.remove("active");
                this.children[0].classList.add('active');
            };
        }
    }, []);
    const [weightUnitListData] = useState(WeightUnitData);

    const initialInputData = {
        weight_unit_name: '',
    };
    const [inputData, setInputData] = useState({ ...initialInputData });
    const handleWeightUnitInputChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleWeightUnitSubmit = (e) => {
        e.preventDefault();
    };
    const weightUnitRows = [
        {
            columns: [
                { size: { md: 12 }, label: 'Weight Unit Name', type: 'text', placeholder: 'Enter new weight unit...', name: 'weight_unit_name', id: 'weightUnitName', value: inputData.weight_unit_name, errormsg: '', },
            ],
        },
    ];
    const weightUnitButtons = [
        { variant: "primary", text: "Add", onClick: handleWeightUnitSubmit },
        { variant: "secondary", text: "Cancel" },
    ];

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className='d-md-flex justify-content-between align-items-center'>
                                            <Form className='custom-form-width'>
                                                <div className='custom-search-bar'>
                                                    <Icon path={mdiMagnify} size={1} className="custom-search-input-icon" />
                                                    <Form.Control className='' type="text" placeholder="Search service category..." name='serviceCategorySearch' id='serviceCategorySearch' />
                                                </div>
                                            </Form>
                                            <div className="custom-top-nav-tab mt-3 mt-md-0">
                                                <ul className="nav nav-pills btn-list" id="pills-tab" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link active" id="pills-view-weight-unit-tab" data-bs-toggle="pill" data-bs-target="#pills-view-weight-unit" type="button" role="tab" aria-controls="pills-view-weight-unit" aria-selected="true">
                                                            <Icon path={mdiFormatListBulletedSquare} className="btn-icon me-1" />View Weight Unit
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link" id="pills-new-weight-unit-tab" data-bs-toggle="pill" data-bs-target="#pills-new-weight-unit" type="button" role="tab" aria-controls="pills-new-weight-unit" aria-selected="false">
                                                            <Icon path={mdiPlus} className="btn-icon me-1" />New Weight Unit
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={4} xxl={3}>
                                <Card className='procust-left-list leftbar-list'>
                                    <SimpleBarReact>
                                        <Card.Body>
                                            <div className='left-list-bar'>
                                                {weightUnitListData.weightUnitList.map((data, i) =>
                                                    <Nav.Item className='left-link-item' key={i}>
                                                        <Nav.Link className={i === 0 ? "active" : ""}>
                                                            <h5 className='product-tab-title'>{data.weightUnitLink}</h5>
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                )}
                                            </div>
                                        </Card.Body>
                                    </SimpleBarReact>
                                </Card>
                            </Col>
                            <Col lg={8} xxl={9}>

                                <div className="tab-content custom-top-nav-tab" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="pills-view-weight-unit" role="tabpanel" aria-labelledby="pills-view-weight-unit-tab" tabIndex="0">
                                        <ViewWeightUnit />
                                    </div>
                                    <div className="tab-pane fade" id="pills-new-weight-unit" role="tabpanel" aria-labelledby="pills-new-weight-unit-tab" tabIndex="0">
                                        <Card className='right-content-details'>
                                            <Card.Body>
                                                <Card.Title>New Weight Unit</Card.Title>
                                                <FormInputs Buttons={weightUnitButtons} rows={weightUnitRows} handleInputChange={handleWeightUnitInputChange} handleSubmit={handleWeightUnitSubmit} />
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
